import { Hashtracking } from "@otto-ec/global-hashtracking";
import { GlobalEvents } from "../../exports/event-q-bus";
import { o_global } from "../namespaces";

o_global
  .events<GlobalEvents>()
  .on("assets.events.windowLoad", () => new Hashtracking().hashTrack());
